import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions as supportActions } from "../../actions/supportActions";
import { actions as accountActions } from "../../actions/accountActions";
import RaterWrapper from "./RaterWrapper";
import { GOODBYE_MESSAGES } from "../../constants/constants";
import { isValidEmailAddress } from "../../helpers/validation";
import * as types from "../../constants/actionTypes";
import LoginStyleWrapper from "../Common/LoginStyleWrapper/LoginStyleWrapper";
import TextArea from "../Common/TextArea";
import Button from "../Common/Button";
import InputText from "../Common/InputText";
import Notification from "../Common/Notification";
import LoadingIndicator from "../Common/LoadingIndicator/LoadingIndicator";
import "react-rater/lib/react-rater.css";
import "./LogoutPage.scss";

class LogoutPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isFeedbackSent: false,
            isSendingFeedback: false,
            isFormValid: true,
            placeholderText: "",
            goodbyeMessage: "",
            feedback: "",
            email: "",
            rating: null,
            userKey: "",
        };
    }

    componentDidMount() {
        // Save the userKey from state to local var BEFORE it's cleared on logout
        this.setState({ userKey: this.props.userKey });

        if (!this.props.hasLoggedOut) {
            this.props.accountActions.logout();
        }

        const randomIndex = Math.floor(Math.random() * GOODBYE_MESSAGES.length);
        this.setState({ goodbyeMessage: GOODBYE_MESSAGES[randomIndex] });
    }

    sendFeedback = async () => {
        try {
            this.setState({ isSendingFeedback: true });
            const response = await this.props.supportActions.giveFeedback(
                this.state.rating,
                this.state.feedback,
                this.state.email,
                this.state.userKey
            );
            if (response.type === types.SUBMIT_FEEDBACK_SUCCESS) {
                this.setState({ isFeedbackSent: true });
            } else if (response.type === types.SUBMIT_FEEDBACK_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isSendingFeedback: false });
        }
    };

    onRate = (obj) => {
        const msg =
            obj.rating <= 4 ? "What can we do better?" : "What did you like?";
        this.setState({ placeholderText: msg, rating: obj.rating });
    };

    onChange = (event) => {
        this.setState({ [event.currentTarget.name]: event.currentTarget.value });
    };

    onSubmitFeedback = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.state.email) {
            this.sendFeedback();
        } else if (
            this.state.email.length === 0 ||
            !isValidEmailAddress(this.state.email)
        ) {
            Notification("error", "Email address is not valid", "");
            this.setState({ isFormValid: false });
        } else {
            this.sendFeedback();
        }
    };

    render() {
        return (
            <LoginStyleWrapper>
                <div className="logout">
                    <p className="goodbye mb-4">{this.state.goodbyeMessage}</p>
                    <LoadingIndicator isLoading={this.state.isSendingFeedback}>
                        {this.state.isFeedbackSent === false ? (
                            <Fragment>
                                <label className="form-label">
                                    How would you rate your experience today?
                                </label>
                                <div className="stars mb-3">
                                    <RaterWrapper
                                        total={5}
                                        rating={this.state.rating}
                                        interactive={true}
                                        onRate={this.onRate}
                                    />
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <p className="mb-4">Thanks for your feedback.</p>
                            </Fragment>
                        )}

                        {this.state.rating != null && this.state.isFeedbackSent === false && (
                            <form
                                onSubmit={this.onSubmitFeedback}
                                noValidate
                                className={`needs-validation ${this.state.isFormValid ? "" : "was-validated"
                                    }`}
                            >
                                <div className="form-container mb-3">
                                    <TextArea
                                        name="feedback"
                                        value={this.state.feedback}
                                        rows={4}
                                        placeholder={this.state.placeholderText}
                                        isFocused={true}
                                        onChange={this.onChange}
                                    />
                                    <InputText
                                        name="email"
                                        placeholder="Email Address (Optional)"
                                        type="email"
                                        onChange={this.onChange}
                                        errorMessage="Invalid Email"
                                    />
                                    <Button
                                        type="submit"
                                        bootstrapClass="outline-light mb-2 mt-2"
                                        text="Submit Feedback"
                                    />
                                </div>
                            </form>
                        )}
                        <a href="/login">
                            <div className="mb-4 btn btn-outline-light">
                                Click here to Sign In
                            </div>
                        </a>
                    </LoadingIndicator>
                </div>
            </LoginStyleWrapper>
        );
    }
}

LogoutPage.propTypes = {
    supportActions: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    userKey: PropTypes.string,
    hasLoggedOut: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
    return {
        supportActions: bindActionCreators(supportActions, dispatch),
        accountActions: bindActionCreators(accountActions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        userKey: state.user?.userKey || '',
        hasLoggedOut: state.logout.hasLoggedOut,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);
